import React from 'react';
import moment from 'moment';
import {makeStyles, Typography} from '@material-ui/core';
import {CSVLink} from "react-csv";
import {useIntl} from 'react-intl';
import customAxios from "../../API/customAxios";
import CompLeaveBalance from '../../Function/CompLeaveBalance';

const useStyles = makeStyles((theme) => ({
    csvLink: {
        color: 'white',
        '&:hover': {
            color: 'white',
        },
        display: 'contents'
    },
    button: {
        height: '2.8em',
        backgroundColor: '#2C3E50',
        '&:hover': {
            backgroundColor: '#080C0F',
        }
    },
}));

export default function ExportCompLeaveBalance({setIsActive}) {
    const classes = useStyles();
    const intl = useIntl();
    const [csvBalanceRecord, setCsvBalanceRecord] = React.useState([]);
    const [filename, setFilename] = React.useState('');
    const csvLink = React.useRef();
    const fourMonthsAgo = moment().subtract(4, 'months').add(1, 'days').format('YYYY/MM/DD');
    const threeMonthsAgo = moment().subtract(3, 'months').format('YYYY/MM/DD');

    const headers = [
        {label: intl.formatMessage({id: 'leave_approval.staff_number'}), key: "staffNo"},
        {label: intl.formatMessage({id: 'leave_approval.employee'}), key: "employeeName"},
        {label: intl.formatMessage({id: 'leave_approval.position'}), key: "position"},
        {label: intl.formatMessage({id: 'leave_approval.location'}), key: "location"},
        {label: intl.formatMessage({id: 'leave_approval.department'}), key: "department"},
        {label: intl.formatMessage({id: 'hr_admin.staff_duty'}), key: "staffDuty"},
        {label: intl.formatMessage({id: 'table.comp_leave_total'}), key: "total"},
        {label: intl.formatMessage({id: 'table.comp_leave_taken'}), key: "taken"},
        {label: intl.formatMessage({id: 'cash_out.total_cashed_out_hours'}), key: "totalCashedOutHours"},
        {label: intl.formatMessage({id: 'table.comp_leave_balance'}), key: "balance"},
        {label: intl.formatMessage({id: 'table.comp_leave_balance_to_be_expired'}), key: "toBeExpiredBalance"},
        {label: intl.formatMessage(
            {id: 'table.comp_leave_balance_expired'},
            {from: fourMonthsAgo, to: threeMonthsAgo},
        ), key: "recentExpiredBalance"},
    ];

    function getData() {
        setIsActive(true);
        customAxios.get(`/export_comp_leave_balance`)
            .then(res => {
                const csvData = res.data;
                const currentDate = moment().format('YYYY_MM_DD');
                setFilename('Employees_Comp_Leave_Balance_Report_' + currentDate + '.csv');
                setCsvBalanceRecord(CompLeaveBalance(csvData, intl));
                setIsActive(false);
                csvLink.current.link.click();
            })
    }

    return (
        <div>
            <Typography onClick={getData}
                        style={{color: '#000'}}>{intl.formatMessage({id: 'myteam.comp_leave_balance'})}</Typography>
            <CSVLink filename={filename} data={csvBalanceRecord} headers={headers} className={classes.csvLink}
                    ref={csvLink}/>
        </div>
    );
}
